/** Einen per ID zugeordneten Datensatz für die Anzeige auflösen.
 *
 *  Auswahlfelder in DiNo leiten ihren angezeigten Wert oft aus einer geladenen
 *  Liste ab: `liste.find(x => x.id === gespeicherteId) || null`. Steht der
 *  gespeicherte Datensatz nicht in dieser Liste — weil die Liste aus einer
 *  Suche kommt und noch leer ist, oder weil der Datensatz nicht zum Vorgang
 *  gehört —, wird der Wert `null` und das Feld sieht **leer** aus, obwohl eine
 *  Zuordnung besteht. Genau das hat die QS an der Aufgabenmaske gemeldet
 *  (qs/dino-qs#7) und an den Zahlungsschuldnern (#8).
 */

/** Den Datensatz zur ID aus dem Pool holen, falls er dort steht. */
export const pickFromPool = <T, K extends keyof T & string>(
  pool: T[] | undefined,
  idField: K,
  id: number | null | undefined
): T | undefined => {
  if (typeof id !== 'number') return undefined;
  return (pool ?? []).find(entry => (entry[idField] as unknown) === id);
};

/** Muss der Datensatz nachgeladen werden?
 *
 *  Nur wenn eine brauchbare ID gesetzt ist und der Pool sie nicht auflösen
 *  konnte. Nicht gespeicherte Datensätze tragen negative Platzhalter-IDs — die
 *  gibt es serverseitig nicht und dürfen keinen Abruf auslösen.
 */
export const needsLookup = <T>(
  id: number | null | undefined,
  resolved: T | undefined
): boolean => typeof id === 'number' && id > 0 && resolved === undefined;
